module.exports = __webpack_public_path__ + "img/drop.a7fe1ceb.svg";